import { Component, Input } from '@angular/core';
import {
	NON_US_PRIVACY_POLICY_URL,
	NON_US_TERMS_OF_SERVICE_URL,
	US_END_USER_LICENSE_AGREEMENT_URL,
	US_PRIVACY_POLICY_URL,
} from '../app.constants';
import { ExternalLinkDirective } from '../directives/external-link.directive';

@Component({
	selector: 'app-tos-and-privacy-policy',
	templateUrl: './tos-and-privacy-policy.component.html',
	styleUrls: ['./tos-and-privacy-policy.component.scss'],
	imports: [ExternalLinkDirective],
})
export class TOSAndPrivacyPolicyComponent {
	@Input() showAgreeText: boolean = false;

	readonly nonUsPrivacyPolicyUrl = NON_US_PRIVACY_POLICY_URL;
	readonly usPrivacyPolicyUrl = US_PRIVACY_POLICY_URL;
	readonly nonUsTermsOfServiceUrl = NON_US_TERMS_OF_SERVICE_URL;
	readonly usEndUserLicenseAgreementUrl = US_END_USER_LICENSE_AGREEMENT_URL;
}
